import { SCREENS, REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = { currentScreen: SCREENS.PROGRESS };

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return { currentScreen: payload };

    // on end of round, return to Progress Screen
    case REDUX_ACTIONS.ROUND_END:
      return { currentScreen: SCREENS.PROGRESS };

    // when a round starts, go to the Standard View screen
    case REDUX_ACTIONS.ROUND_START:
      return {
        currentScreen: SCREENS.ANIMATED_TRANSITION,
      };

    default:
      return state;
  }
};

export default screenReducer;
